<template lang="">
  <div>
    <VueAwesomeSideBar
      v-model:miniMenu="miniMenu"
      v-model:collapsed="collapsed"
      :menu="testMenu"
      @item-click="onItemClick"
    ></VueAwesomeSideBar>
  </div>
</template>

<script setup>
  import VueAwesomeSidebar from 'vue-awesome-sidebar'
  import 'vue-awesome-sidebar/dist/vue-awesome-sidebar.css'
  import { ref } from 'vue'

  const props = defineProps({
    msg: String,
    userLeagues: {
      type: Array,
      default: () => [],
    },
  });

  const collapsed = ref(false)
  const miniMenu = ref(true)

  const onItemClick = (menuItem) => {
    if (!menuItem) return
    if (menuItem.name === 'Logout') {
      logoutUser()
      return
    }
    if (menuItem.href) {
      window.location.assign(menuItem.href)
    }
  }

  // TODO all this seems hacky, cleanup
  const getCsrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }

  const logoutUser = async () => {
    try {
      const response = await fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml, application/json'
        },
        credentials: 'include'
      })
      if (response.ok) {
        window.location.assign('/home')
      } else {
        // Fallback: hard redirect to sign_out route to let Rails handle it
        window.location.assign('/users/sign_out')
      }
    } catch (e) {
      window.location.assign('/users/sign_out')
    }
  }

  const testMenu = [
    {
      name: 'My Leagues',
      icon: { class: 'fa-solid fa-trophy' },
      children: props.userLeagues.map(league => ({ name: league.name, href: league.challengesPath, icon: { class: 'fa-solid fa-football' } })),
    },
    {
      name: 'Settings',
      icon: { class: 'fa-solid fa-gears' },
      href: '/settings',
    },
    {
      name: 'Logout',
      icon: { class: 'fa-solid fa-power-off' },
    }
  ]
</script>
<style lang="">
  
</style>